import clsx from "clsx"
import FormInput from "components/auth/formInput"
import FormTextArea from "components/auth/formTextArea"
import { emailPattern } from "lib/forms"
import { useState } from "react"
import { useForm } from "react-hook-form"
import toast from "react-hot-toast"
import Modal from "../auth/modal"

export default function SendToAFriend({ iconClassName, postTitle, modalClassName }) {
	const { register, handleSubmit, formState: { isSubmitting, errors } } = useForm({
		values: { emailName: "", friendEmail: "", msg: "" },
	})

	const [show, setShow] = useState(false)
	const onOpen = () => setShow(true)
	const onClose = () => setShow(false)

	const onSubmit = handleSubmit(async data => {

		return fetch("/api/nb/v3/send-to-a-friend", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ ...data, url: location.href, title: postTitle }),
		})
			.then(r => r.json())
			.then(r => {
				if (!r.resp) throw new Error(r.msg)

				toast.success("Η αποστολή ήταν επιτυχής!")

			}).catch(e => toast.error(e.message))
	})

	return (
		<>
			<button data-type="email" className={clsx(...iconClassName)} onClick={onOpen}>
				<svg>
					<use xlinkHref="#IconCircleMail" />
				</svg>
			</button>
			<Modal show={show} onClose={onClose}>
				<div className={modalClassName}>
					<form onSubmit={onSubmit} >
						<FormInput
							placeholder="Το όνομά σου"
							error={errors.emailName?.message}
							{...register("emailName", {
								required: "Αυτό το πεδίο είναι υποχρεωτικό",
								minLength: { value: 3, message: "Το όνομα πρέπει να έχει τουλάχιστον 3 χαρακτήρες" },
								maxLength: { value: 30, message: "Το όνομα δεν μπορεί να ξεπερνά τους 30 χαρακτήρες" },
							})}
						/>

						<FormInput
							error={errors.email?.message}
							type="email"
							placeholder="Το email του φίλου σου"
							{...register("friendEmail", {
								required: "Αυτό το πεδίο είναι υποχρεωτικό",
								pattern: { value: emailPattern, message: "Ελέγξτε ξανά το email!" }
							})}
						/>

						<FormTextArea
							rows={1}
							placeholder="Μήνυμα"
							className="autoGrow"
							error={errors.msg?.message}
							{...register("msg", {
								required: "Αυτό το πεδίο είναι υποχρεωτικό",
								maxLength: { value: 1000, message: "Το σχόλιο δεν μπορεί να ξεπερνά τους 1000 χαρακτήρες" },
							})}
						/>


						<button className="cmnBtn" type="submit" disabled={isSubmitting}>Αποστολή</button>
					</form>
				</div>

			</Modal>
		</>
	)
}